import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import { Link, withRouter } from 'react-router';
import { clone } from 'lodash';
import {
  Button,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Select,
  Table,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import qs from 'qs';
import SearchFilter from '../../../../components/SearchFilter';
import SortButton from '../../../../components/SortButton';
import PageNav from '../../../../components/PageNav';
import HIMSUnitSync from '../../../modals/HIMSUnitSync';
import ConfirmHIMSUnitSync from '../../../modals/ConfirmHIMSUnitSync';
import config from '../../../../../config';
import { fetchM } from '../../../../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage } from '../../../../actions/flash';
import { decodeSearch, encodeSearch } from '../../../../utils/url';
import isNumber from '../../../../utils/numbers/isNumber';
import { HIMS_UNIT_FIELDS, HIMS_UNIT_NUMBER, HIMS_UNIT_MAIN_FIELDS } from '../../../../constants/hims';

moment.locale('en-gb');

class UnitList extends Component {
  static propTypes = {
    params: PropTypes.shape({
      himsSettingID: PropTypes.string,
      componentID: PropTypes.string,
    }),
    id: PropTypes.string,
    project: PropTypes.object,
    loading: PropTypes.bool,
    himsSettings: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      himsDevelopmentCode: PropTypes.string,
    })),
    componentData: PropTypes.array,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      query: PropTypes.object,
    }),
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    isLargeScreen: PropTypes.bool,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const componentData = props.componentData || [];
    const himsSettingID = props.params.himsSettingID || '';
    const componentID = props.params.componentID || '';
    return {
      componentData,
      currentPage,
      himsSettingID,
      componentID,
    };
  }
  constructor(props) {
    super(props);
    const state = UnitList.getPropsToState(props);
    const query = decodeSearch(props.location.search);
    const search = query.search || '';
    const limit = 20;
    const currentPage = parseInt(query.page, 10) || 1;
    const offset = (currentPage - 1) * limit;
    this.state = {
      limit,
      offset,
      currentPage,
      search,
      data: [],
      componentData: [],
      count: 0,
      loading: true,
      himsUnitsLoading: true,
      showModal: false,
      showConfirmModal: false,
      confirmHIMSUnit: '',
      confirmSRUnit: '',
      srUnits: [],
      ...state,
    };
  }
  componentDidMount() {
    const { query } = this.props.location;
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    this.fetchShowroomUnits();
    this.fetchUnitCustomFieldSettings();
    if (this.state.componentID) {
      this.fetchHIMSUnits(query);
    }
  }
  componentWillReceiveProps(nextProps) {
    const state = UnitList.getPropsToState(nextProps);
    const newQuery = decodeSearch(nextProps.location.search);
    const shouldFetchHIMSUnits = (
      !this.state.himsUnitsLoading &&
      nextProps.params.componentID !== this.props.params.componentID &&
      state.himsSettingID && state.componentID
    );
    this.setState({ ...state }, () => {
      if (shouldFetchHIMSUnits) {
        this.fetchHIMSUnits(newQuery);
      } else {
        this.getDataByPage(newQuery.page || 1);
      }
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  setHimsUnitsLoading(himsUnitsLoading = false) {
    return new Promise((res) => {
      this.setState({ himsUnitsLoading }, () => {
        res(himsUnitsLoading);
      });
    });
  }
  getDataByPage = (page, replaceQuery = false) => {
    const { oriData, limit, sortDirection, search } = this.state;
    let data = oriData || [];
    let count = data.length || 0;
    if (sortDirection) {
      data = this.sortByShowroomUnit();
    }
    if (search) {
      data = data.filter(d => d.no_unit.includes(search));
      count = data.length;
    }
    const query = decodeSearch(this.props.location.search);
    const currentPage = parseInt(page, 10);
    const offset = (currentPage - 1) * limit;
    query.page = currentPage;
    data = data.slice((page - 1) * limit, page * limit);
    this.setState({ data, currentPage, count, offset });
    if (replaceQuery) this.replaceQuery(query);
  }
  setSRUnits(data = []) {
    return new Promise((res) => {
      this.setState({
        srUnits: data || [],
      }, () => {
        res(data);
      });
    });
  }
  sortByShowroomUnit = () => {
    const { oriData, sortDirection } = this.state;
    let data = [];
    const unitsWithSR = oriData.filter(d => d.showroomUnit);
    const unitsWithoutSR = oriData.filter(d => !d.showroomUnit);
    if (sortDirection === 'desc') {
      unitsWithSR.sort((a, b) => b.showroomUnit.reference.localeCompare(a.showroomUnit.reference));
      data = unitsWithoutSR.concat(unitsWithSR);
    } else {
      unitsWithSR.sort((a, b) => a.showroomUnit.reference.localeCompare(b.showroomUnit.reference));
      data = unitsWithSR.concat(unitsWithoutSR);
    }
    return data;
  }
  fetchHIMSUnits = async (q = {}) => {
    const { id } = this.props;
    const { himsSettingID, componentID, limit } = this.state;
    const { store } = this.context;
    if (!componentID) {
      return;
    }
    await this.setHimsUnitsLoading(true);
    const query = Object.assign({}, q);
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${id}/hims/${himsSettingID}/components/${componentID}/units/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setHimsUnitsLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      const count = data ? data.length : 0;
      const currentPage = parseInt(query.page, 10) || 1;
      const offset = (currentPage - 1) * limit;
      await this.setComponentState({
        count,
        offset,
        oriData: clone(data) || [],
        data: [],
        himsToken: token,
      });
      this.getDataByPage(currentPage || 1, true);
    }
    await this.setHimsUnitsLoading(false);
  }
  async fetchShowroomUnits() {
    await this.setLoading(true);
    const { store } = this.context;
    const query = {
      limit: 0,
    };
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/units/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      await this.setComponentState({ token });
      await this.setSRUnits(data);
    }
    await this.setLoading(false);
  }
  async fetchUnitCustomFieldSettings() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/unit_custom_fields/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    } else {
      const unitCustomFieldSettingsData = await res.json();
      await this.setComponentState({
        unitCustomFieldSettings: unitCustomFieldSettingsData,
      });
      await this.setLoading(false);
    }
  }
  async autoSyncUnits() {
    await this.setLoading(true);
    const { store } = this.context;
    const { id } = this.props;
    const { himsSettingID, componentID } = this.state;
    try {
      await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${id}/hims/${himsSettingID}/components/${componentID}/units/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.himsToken,
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    // refetch page
    const query = decodeSearch(this.props.location.search);
    this.fetchHIMSUnits(query);
    store.dispatch(flashSuccessMessage({
      header: 'Auto Sync Units Success',
      message: 'Units successfully updated',
    }));
  }
  async syncUnit() {
    await this.setLoading(true);
    const { store } = this.context;
    const unit = this.state.syncUnitData;
    try {
      await store.dispatch(fetchM(`/projects/${this.props.id}/units/${unit.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(unit),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    if (this.state.oldUnitData) {
      this.removeHimsFromOldUnit();
    } else {
      // refetch page
      const query = decodeSearch(this.props.location.search);
      this.fetchShowroomUnits();
      this.fetchHIMSUnits(query);
      store.dispatch(flashSuccessMessage({
        header: 'Sync Unit Success',
        message: 'Unit successfully updated',
      }));
    }
  }
  async removeHimsFromOldUnit() {
    await this.setLoading(true);
    const { store } = this.context;
    const unit = this.state.oldUnitData;
    if (unit.projectUnitCustomFields) {
      unit.projectUnitCustomFields = unit.projectUnitCustomFields.map((p) => {
        let { value } = p;
        if (HIMS_UNIT_FIELDS.includes(p.projectUnitCustomFieldSettingID)) {
          value = '';
        }
        return {
          ...p,
          value,
        };
      }) || [];
    }
    try {
      await store.dispatch(fetchM(`/projects/${this.props.id}/units/${unit.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(unit),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    // refetch page
    const query = decodeSearch(this.props.location.search);
    this.fetchHIMSUnits(query);
    store.dispatch(flashSuccessMessage({
      header: 'Sync Unit Success',
      message: 'Unit successfully updated',
    }));
  }
  handleChangePage = (page) => {
    const { limit } = this.state;
    const query = decodeSearch(this.props.location.search);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    const currentPage = parseInt(page || query.page, 10);
    const offset = (currentPage - 1) * limit;
    query.page = currentPage;
    this.setState({ currentPage, offset });
    this.replaceQuery(query);
  }
  handleFilterOnChange = (value) => {
    this.setState({ search: value }, () => {
      this.getDataByPage(1, true);
    });
  }
  handleClearFilter = (...queryArray) => {
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      delete query[filter];
      if (filter === 'search') {
        this.setState({
          search: '',
        });
      }
    });
    this.replaceQuery(query);
  }
  handleOnHimsSettingChange = (e, d) => {
    this.setState({ himsSettingID: d.value, componentID: '' }, () => {
      this.replaceQuery(1);
    });
  }
  handleOnComponentChange = (e, d) => {
    this.setState({ componentID: d.value }, () => {
      this.replaceQuery(1);
    });
  }
  replaceQuery(query) {
    const { store } = this.context;
    const { himsSettingID, componentID } = this.state;
    store.dispatch(replace(`/projects/${this.props.id}/units/hims/${himsSettingID}/components/${componentID ? `${componentID}/` : ''}?${encodeSearch(query)}`));
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  handleSort = () => {
    const { sortDirection } = this.state;
    const direction = sortDirection === 'asc' ? 'desc' : 'asc';
    this.setState({ sortDirection: direction }, () => {
      this.getDataByPage(1, true);
    });
  }
  handleOnEditUnit = (e, value) => {
    e.preventDefault();
    const selectedUnit = value;
    this.setState({ showModal: true, selectedUnit });
  }
  handleCloseModal = () => {
    this.setState({ showModal: false });
  }
  checkSrUnitHasHimsData = unit => unit && unit.projectUnitCustomFields &&
    unit.projectUnitCustomFields.reduce((count, cf) => {
      if (
        HIMS_UNIT_MAIN_FIELDS.includes(cf.projectUnitCustomFieldSettingID) &&
        cf.value
      ) {
        return count + 1;
      }
      return count;
    }, 0) === HIMS_UNIT_MAIN_FIELDS.length;
  mapSrUnitHimsData = (unit) => {
    const srUnitHimsData = {};
    if (unit) {
      srUnitHimsData.id = unit.id;
      srUnitHimsData.reference = unit.reference;
      if (unit.projectUnitCustomFields) {
        unit.projectUnitCustomFields.forEach((cf) => {
          if (HIMS_UNIT_MAIN_FIELDS.includes(cf.projectUnitCustomFieldSettingID)) {
            srUnitHimsData[cf.projectUnitCustomFieldSettingID] = cf.value;
          }
        });
      }
    }
    return srUnitHimsData;
  }
  handleConfirmModal = (e, d, oldUnit) => {
    this.setState({
      syncUnitData: d,
      oldUnitData: oldUnit,
    });
    // check if the SR unit is synced with other HIMS unit
    const { data, srUnits } = this.state;
    const currentUnit = srUnits.find(unit => unit.id === d.id);
    const himsUnitWithSameSRID = data.find(hu => hu.showroomUnitID === d.id);
    const currentUnitHasHims = this.checkSrUnitHasHimsData(currentUnit);
    if (himsUnitWithSameSRID || currentUnitHasHims) {
      this.setState({
        confirmHIMSUnit: this.mapSrUnitHimsData(
          himsUnitWithSameSRID
            ? himsUnitWithSameSRID.showroomUnit
            : currentUnit),
        confirmSRUnit: this.mapSrUnitHimsData(d),
      }, () => {
        this.handleShowReconfirmModal(e);
      });
    } else {
      this.handleSyncUnit();
    }
  }
  handleShowReconfirmModal = () => {
    this.setState({ showConfirmModal: true });
  }
  handleCloseConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  }
  handleSyncUnit = () => {
    this.setState({
      showModal: false,
      showConfirmModal: false,
    }, () => {
      this.syncUnit();
    });
  }
  handleAutoSyncUnits = () => {
    this.autoSyncUnits();
  }
  renderMobileCell = value => (
    <Table.Cell className="computer-hide">
      {value.no_unit}
      <br />
      {value.no_lot_pt}
      <br />
      RM {value.harga_jualan.toFixed(2)}
      <br />
      {value.status_jualan === 1 ? 'SOLD' : ''}
      {value.status_pembeli_pertama === 1 && <Label size="mini" style={value.status_jualan === 1 ? { marginLeft: '0.5em' } : {}} color="green">1st Buyer</Label>}
    </Table.Cell>
  );
  renderBody() {
    const { data, himsUnitsLoading, isMobile, loading } = this.state;
    const isLoading = loading || himsUnitsLoading;
    return (
      !isLoading && data.length > 0 ?
        data.map((value, idx) => (
          <Table.Row key={idx}>
            {this.renderMobileCell(value)}
            <Table.Cell className="mobile-hide">
              {value.no_unit}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.no_lot_pt}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.harga_jualan.toFixed(2)}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.luas_tanah.toFixed(2)}
            </Table.Cell>
            <Table.Cell className="mobile-hide">
              {value.luas_binaan.toFixed(2)}
            </Table.Cell>
            <Table.Cell collapsing className="mobile-hide">
              {value.harga_spjb.toFixed(2)}
            </Table.Cell>
            <Table.Cell collapsing className="mobile-hide" textAlign="center">
              <p style={{ margin: 0 }}>{value.status_jualan === 1 ? 'Yes' : 'No'}</p>
              {value.status_pembeli_pertama === 1 && <Label size="mini" style={{ marginTop: '0.5em' }} color="green">1st Buyer</Label>}
            </Table.Cell>
            {
              value.showroomUnitID ? (
                <Table.Cell width={2} textAlign="center" onClick={e => this.handleOnEditUnit(e, value)}>
                  <Grid.Column mobile={3} tablet={2} computer={2} textAlign="center">
                    <Icon
                      name="edit"
                      color="grey"
                      style={{ fontSize: '1em' }}
                    />
                    <Link>
                      {value.showroomUnit.reference}
                    </Link>
                  </Grid.Column>
                  {value.showroomUnit.isBumi && <Label size="mini" style={{ marginTop: '0.5em' }}>Bumi</Label>}
                </Table.Cell>
              ) : (
                <Table.Cell colSpan={isMobile ? 1 : 2} textAlign="center">
                  <Button
                    className="ui compact icon primary button"
                    onClick={e => this.handleOnEditUnit(e, value)}
                  >
                    <Icon name="edit" />
                  </Button>
                </Table.Cell>
              )
            }
            {
              value.showroomUnitID ? (
                <Table.Cell collapsing className="mobile-hide">
                  {
                    value.showroomUnit && value.showroomUnit.projectUnitCustomFields &&
                    value.showroomUnit.projectUnitCustomFields.length > 0 &&
                    value.showroomUnit.projectUnitCustomFields.find(
                      pucf => pucf.projectUnitCustomFieldSettingID === HIMS_UNIT_NUMBER,
                    ).value
                  }
                </Table.Cell>
              ) : null
            }
          </Table.Row>
        ))
      :
        <Table.Row>
          <Table.Cell colSpan="100%" textAlign="center">
            {
              isLoading ?
                <Loader active inline="centered">Loading</Loader>
              : <p>No units found.</p>
            }
          </Table.Cell>
        </Table.Row>
    );
  }
  renderTable() {
    const { id, componentData, isMobile, isTablet, isLargeScreen, himsSettings } = this.props;
    const { himsSettingID, componentID, himsUnitsLoading, loading } = this.state;
    const isLoading = loading || himsUnitsLoading;
    const exportItems = [
      {
        text: 'Excel',
        icon: 'download',
        href: `${config.get('bookApiURL')}/projects/${id}/hims/${himsSettingID}/components/${componentID}/units/export/`,
      },
    ];
    return (
      <Table
        celled
        unstackable
        structured
      >
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan="100%">
              <Grid columns={1} verticalAlign="middle">
                <Grid.Column>
                  <SearchFilter
                    inTable
                    searchWidth={isMobile ? 16 : (isTablet ? 13 : 4)}
                    rightNavWidth={(isMobile || isTablet) ? 16 : 10}
                    leftNavWidth={isMobile ? 16 : (isTablet ? 3 : 2)}
                    isLoading={isLoading}
                    onChange={this.handleFilterOnChange}
                    onClose={this.handleClearFilter}
                    search={this.state.search}
                    advanceFilter={this.state.advanceFilter}
                    leftNav={(
                      <Header style={{ marginLeft: '0.5em', marginTop: '0.25em' }}>
                        Unit List
                      </Header>
                    )}
                    rightNav={(
                      <div style={isTablet ? { marginTop: '1.5em' } : {}}>
                        <Select
                          disabled={himsSettings.length === 0 || isLoading}
                          loading={isLoading}
                          onChange={this.handleOnHimsSettingChange}
                          value={himsSettingID}
                          placeholder="Select Project Code"
                          options={himsSettings.map(hs => ({
                            value: hs.id,
                            text: `Project Code (${hs.himsDevelopmentCode})`,
                          }))}
                        />
                        <Select
                          disabled={componentData.length === 0 || isLoading || !himsSettingID}
                          loading={isLoading}
                          onChange={this.handleOnComponentChange}
                          value={componentID}
                          placeholder="Select Component ID"
                          options={componentData.map(c => ({
                            value: c.pembangunan_id,
                            text: `Component ID (${c.pembangunan_id})`,
                          }))}
                          style={{ marginLeft: '0.5em' }}
                        />
                        <SortButton
                          loading={isLoading}
                          icon="download"
                          items={exportItems}
                          disabled={!himsSettingID || !componentID}
                        />
                        <Button
                          style={{
                            ...(!isTablet && (isMobile || !isLargeScreen) ? { marginTop: '0.5em' } : {}),
                            marginRight: 0,
                            marginLeft: '0.5em',
                          }}
                          primary
                          icon={isMobile}
                          disabled={!himsSettingID || !componentID || isLoading}
                          onClick={this.handleAutoSyncUnits}
                        >
                          <Icon name="redo" />
                          {!isMobile && 'Auto Sync Units'}
                        </Button>
                      </div>
                    )}
                  />
                </Grid.Column>
              </Grid>
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell colSpan={isMobile ? 1 : 7}>
              <Header style={{ marginLeft: '0.5em', marginTop: '0.25em' }}>
                HIMS
              </Header>
            </Table.HeaderCell>
            <Table.HeaderCell
              colSpan={isMobile ? 1 : 2}
              collapsing
              width={isMobile ? 8 : 3}
              onClick={() => this.handleSort()}
              style={{ background: '#E9ECF0', cursor: 'pointer' }}
            >
              <Grid.Row style={{ marginLeft: '0.5em', marginTop: '0.25em' }}>
                <Header style={{ display: 'inline-block', marginBottom: '0' }}>
                  Showroom
                </Header>
                <Icon
                  style={{ float: 'right', color: '#767676' }}
                  name="exchange"
                  rotated="clockwise"
                />
              </Grid.Row>
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell className="mobile-hide">No. Unit</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">No. Lot PT</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Harga Jualan (RM)</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Keluasan Tanah (MPS)</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Keluasan Binaan (MPS)</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide" width={2}>Harga SPJB (RM)</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide">Sold Status</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide" style={{ background: '#E9ECF0' }}>Unit</Table.HeaderCell>
            <Table.HeaderCell className="mobile-hide" style={{ background: '#E9ECF0' }}>HIMS Unit</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.renderBody()}
        </Table.Body>
      </Table>
    );
  }
  render() {
    const { himsSettings } = this.props;
    const {
      count,
      limit,
      offset,
      himsUnitsLoading,
      loading,
      currentPage,
      selectedUnit,
      showModal,
      showConfirmModal,
      confirmHIMSUnit,
      confirmSRUnit,
      srUnits,
      unitCustomFieldSettings,
      himsSettingID,
    } = this.state;
    const isLoading = loading || himsUnitsLoading;
    return (
      <Grid>
        <HIMSUnitSync
          open={showModal}
          himsSetting={himsSettingID &&
            himsSettings && himsSettings.length > 0 ?
            himsSettings.find(hs => hs.id === himsSettingID) : null}
          data={selectedUnit || {}}
          srUnits={srUnits}
          unitCustomFieldSettings={unitCustomFieldSettings}
          onClose={this.handleCloseModal}
          onConfirm={this.handleConfirmModal}
        />
        <ConfirmHIMSUnitSync
          open={showConfirmModal}
          himsUnit={confirmHIMSUnit}
          srUnit={confirmSRUnit}
          onClose={this.handleCloseConfirmModal}
          onConfirm={this.handleSyncUnit}
        />
        <Grid.Column width={16} textAlign="center">
          {this.renderTable()}
          <Grid.Column style={{ marginTop: '3em' }} textAlign="center">
            <PageNav
              currentPage={currentPage}
              count={count}
              limit={limit}
              offset={offset}
              dataSize={this.state.data.length}
              loading={isLoading}
              onChange={this.handleChangePage}
            />
          </Grid.Column>
        </Grid.Column>
      </Grid>
    );
  }
}

export default withRouter(UnitList);



// WEBPACK FOOTER //
// ./src/containers/Project/Units/HIMSUnitSync/UnitList.jsx